import assets from "app/assets";
import config from "config";
import { gsap } from "gsap";
import { BaseTexture, Container, Graphics, Sprite, Text, TextStyle, Texture } from "pixi.js";
import tools from "tools";
import Btn2 from "./btn2";
const PIC_SIZE = 65;
export default class Objectif extends Container {
  constructor() {
    super();
    tools.autobind(this);
    this._build();
  }
  _build() {
    this._sprite = new Sprite(assets.textures.objectif.texture);
    this._sprite.anchor.set(.5);
    this._sprite.scale.set(.87);
    this.addChild(this._sprite);
    const style = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 25,
      fill: '#2c5f9a'
    });
    this._title = new Text("Friend", style);
    this._title.anchor.set(.5);
    this._title.y = -40;
    // this._title.x = -106;
    this.addChild(this._title);
    this._tmpText = new Text("", style);
    this._tmpText.anchor.set(.5);
    const emojiStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 24,
      fill: '#2c5f9a'
    });
    this._emoji = new Text("🎯", emojiStyle);
    this._emoji.anchor.y = .5;
    this._emoji.anchor.x = 1;
    this._emoji.y = -40;
    this._emoji.x = -this._title.width / 2 - 2;
    this.addChild(this._emoji);
    const scoreStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 22,
      fill: '#2c5f9a',
      wordWrap: true,
      wordWrapWidth: 200,
      lineHeight: 20
    });
    this._score = new Text(null, scoreStyle);
    this._score.x = -70;
    this._score.y = -20;
    this.addChild(this._score);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 18,
      fill: '#2c5f9a',
      wordWrap: true,
      wordWrapWidth: 212,
      lineHeight: 17
    });
    this._text = new Text("", textStyle);
    this._text.anchor.y = .5;
    this._text.x = -70;
    this._text.y = 26;
    this.addChild(this._text);
    this._pic = new Sprite(new Texture(new BaseTexture()));
    this._pic.anchor.set(.5);
    this.addChild(this._pic);
    let __mask = new Graphics();
    __mask.beginFill(0xff0000);
    __mask.drawRoundedRect(-PIC_SIZE / 2, -PIC_SIZE / 2, PIC_SIZE, PIC_SIZE, 12);
    __mask.endFill();
    __mask.x = -111;
    __mask.y = 15;
    this.addChild(__mask);
    this._pic.mask = __mask;
    this._pic.x = __mask.x;
    this._pic.y = __mask.y;
    this.inviteBtn = new Btn2("challenge\nthem !", 20, 0xffffff, 0x3C2FA1, assets.textures.friendsPicto.texture, {
      width: 205,
      height: 80
    }, .65);
    this.inviteBtn.click = this._inviteClick;
    this.inviteBtn.y = 15;
    this.inviteBtn.x = -77;
    this.inviteBtn.visible = false;
    this.addChild(this.inviteBtn);
    this.visible = false;
  }
  _inviteClick() {}
  set profilePic(path) {
    this._pic.texture = path == "default" ? assets.textures.default.texture : Texture.from(path);
    this._pic.width = PIC_SIZE;
    this._pic.height = PIC_SIZE;
  }
  set score(val) {
    this._score.text = val;
    if (val == "") {
      this._text.y = 15;
    } else {
      this._text.y = 26;
    }
  }
  get score() {
    return parseInt(this._score.text);
  }
  set profileName(val) {
    this._title.text = tools.camelCase(val);
    this._tmpText.text = tools.camelCase(val);
    if (this._tmpText.width >= 154) {
      this._title.width = 154;
      this._title.scale.y = this._title.scale.x;
    } else {
      this._title.width = this._tmpText.width;
      this._title.height = this._tmpText.height;
    }
    this._emoji.x = -this._title.width / 2;
  }
  set text(val) {
    this._text.text = val;
    if (this._text.height > 45) {
      let coef = 45 / this._text.height;
      this._text.style.fontSize = 18 * coef;
      this._text.style.lineHeight = 17 * coef;
      this._text.style.wordWrapWidth = 212 * (this._text.height / 40);
    }
  }
  set isOpponent(val) {
    this._isOpponent = val;
  }
  get isOpponent() {
    return this._isOpponent;
  }
  set isKilled(val) {
    this._isKilled = val;
  }
  get isKilled() {
    return this._isKilled;
  }
  show() {
    this.scale.set(0);
    this.visible = true;
    gsap.to(this.scale, {
      delay: .15,
      duration: .5,
      x: 1,
      y: 1,
      ease: "back.out(1.5)"
    });
  }
  hide() {
    gsap.to(this.scale, {
      duration: .5,
      x: 0,
      y: 0,
      onComplete: () => {
        this.visible = false;
      }
    });
  }
  kill(onStart, onComplete) {
    this._isKilled = true;
    gsap.to(this.scale, {
      delay: 1,
      duration: .75,
      x: 0,
      y: 0,
      onStart: onStart,
      onComplete: callback => {
        this.visible = false;
        this.isOpponent = false;
        callback && callback();
      },
      onCompleteParams: [onComplete],
      ease: "back.in(1.5)"
    });
  }
  showInviteFriend() {
    this.score = "";
    this.profileName = "challenge friends";
    this.text = "invite new friends to play with you";
    this._text.x = -4;
    this._text.style.fontSize = 17;
    this._text.style.wordWrapWidth = 150;
    this.inviteBtn.visible = true;
    this._pic.visible = false;
    this.scale.set(0);
    this.visible = true;
    gsap.to(this.scale, {
      delay: 1,
      duration: .5,
      x: 1,
      y: 1,
      ease: "back.out(1.5)"
    });
  }
  reset() {
    this._text.x = -70;
    this._text.style.fontSize = 18;
    this._text.style.wordWrapWidth = 212;
    this.inviteBtn.visible = false;
    this._pic.visible = true;
  }
}
